import factory from '@/util/import/MutatorFactory'
import Importer from '@/util/import/Importer'
import { IEntryExported } from '@/types/entry'
import Entry from '@/data/entry-model'
import EntryRepository from '@/data/entry-repository'

// import mutators
import './mutator'

const createImportVault = (extension: string): Entry =>
    EntryRepository.create('vault').setData({
        title: `.${extension} import [${new Date().toLocaleString()}]`,
        icon: 'icon:file-import',
        tags: ['imported'],
        schemaType: 'vault'
    })

const runImport = async (file: File, vaultId?: string): Promise<Entry[]> => {
    const extension = file.name.split('.').pop()!
    const mutator = factory.getMutator(extension)
    await Importer.readFile(file)
    const result = Importer.mutate(mutator)

    const promises: Promise<Entry>[] = []

    const insertEntry = async (entry: IEntryExported, parentId?: string): Promise<void> => {
        const { children, fields, ...data } = entry
        const promise = EntryRepository.create(data.schemaType)
            .setData({
                ...data,
                parentId
            })
            .setFields(fields)
            .save()
        if (children.length > 0) {
            // ensure parent vault is created before children are by awaiting
            // the promise here
            const parent = await promise
            children.forEach((childEntry: IEntryExported) => insertEntry(childEntry, parent.id))
        } else {
            promises.push(promise)
        }
    }

    result.forEach(
        async entry =>
            insertEntry(entry, vaultId || (await createImportVault(extension).save()).id)
    )
    return Promise.all(promises)
}

export default runImport

/**
 * Get all valid file extensions
 *
 * @returns {string[]}
 */
export const validTypes = (): string[] => factory.getTypes().map(type => `.${type}`)
